'use client'

import Link from '@/modules/shared/components/Link'

import { TrendingHsCode } from '@/modules/hs/types/homepage.types'

interface HsCodeRecentProps {
    item: TrendingHsCode
}

const formatTaxRate = (rate: number | null) => {
    if (rate === null || rate < 0) return 'N/A'
    return `${rate}%`
}

export default function HsCodeRecent({ item }: HsCodeRecentProps) {
    return (
        <Link
            href={`/chi-tiet-ma-hs/${item.hsCode}`}
            className="recent-hs-card cl-card-border"
        >
            <div className="recent-hs-code text-lg font-semibold">{item.hsCode}</div>
            <div className="recent-hs-name">{item.description}</div>
            <div className="recent-hs-taxes">
                <div className="recent-hs-tax-column">
                    <div className="recent-hs-tax-label">THUẾ MFN</div>
                    <div>
                        <span className='recent-hs-tax-value rounded text-md font-semibold '>{formatTaxRate(item.taxes.nkud)}</span>
                    </div>
                </div>
                <div className="recent-hs-tax-column">
                    <div className="recent-hs-tax-label ">FTA TỐT NHẤT</div>
                    <div className="recent-hs-tax-value ">
                        <span className='rounded text-md font-semibold '>{item.taxes.nkuddb
                            ? `${formatTaxRate(item.taxes.nkuddb.rate)} (${item.taxes.nkuddb.agreement})`
                            : 'N/A'}</span>
                    </div>
                </div>
            </div>
        </Link>
    )
}
